import { hasCalibratedAvailable } from "@/utility/calibratedAvailabilityMap";
import type { ModelSchema } from "@mm/api-layers.meteomatics.com";

type TableWithModelAndParam = {
  model?: string;
  parameterUnit?: string;
  ens_select?: string;
  calibrated?: boolean;
};

export function normalizeModelParamDependencies<T extends TableWithModelAndParam>(
  current: T,
  patch: Partial<T>,
  weatherModels: ModelSchema[] | null,
): Partial<T> {
  const updated = { ...current, ...patch };
  const next: Partial<T> = { ...patch };

  const modelSchema = weatherModels?.find((m) => m.identifier === updated.model);

  // calibrated
  if ("parameterUnit" in patch || "model" in patch) {
    next.calibrated = hasCalibratedAvailable(updated.parameterUnit, updated.model) as T["calibrated"];
  }

  // ens_select
  if ("model" in patch) {
    if (!modelSchema?.num_ensemble_members) {
      next.ens_select = "" as T["ens_select"];
    } else if (!current.ens_select || current.ens_select === "") {
      next.ens_select = "member:0" as T["ens_select"];
    }
  }

  return next;
}
